import {  POST } from "../../helper/xbi4RestFunctions";
export const createOrgProjectMember = async (
  org_id: any,
  data: any,
  projectId: any
) => {
  const path = `/orgs/${org_id}/projects/${projectId}/members/add_members`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
